import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { useTheme, useUpdateTheme } from "../hooks";
import { ThemeForm } from "../components";

type IUpdateTheme = {
  id: string;
};

export const UpdateTheme: React.FC = () => {
  const { id } = useParams<IUpdateTheme>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useTheme(+id!);
  const { form, submit, loading } = useUpdateTheme({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("Le thème a été modifié avec succès");
    },
  });

  useEffect(() => {
    if (data?.theme?.ok && data?.theme?.result) {
      const { result } = data.theme;
      form.setValue("code", result.code);
      form.setValue("name", result.name);
      form.setValue("promptText", result.promptText);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  return (
    <>
      <Header
        title="Thème"
        subtitle={data?.theme?.result?.name ?? ""}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/themes`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier un thème" />
          <ThemeForm loading={loading} form={form} submit={submit} />
        </div>
      </div>
    </>
  );
};
